// extracted by mini-css-extract-plugin
export default {"imgContainer":"styles_imgContainer__qlldU"};